<template>
  <el-dialog :close-on-click-modal="false" title="选择尺寸组" :visible.sync="isShow" width="800px">
    <el-form :inline="true" :model="searchComposeSizeGroupVO" class="demo-form-inline">
      <el-form-item label="尺寸组类：">
        <el-select v-model="searchComposeSizeGroupVO.groupCategoryId" clearable placeholder="请选择">
          <el-option label="" value="">全部</el-option>
          <el-option v-for="item in sizeGroupTypeList" :key="item.id" :label="item.categoryName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="尺寸组名称：">
        <el-input v-model="searchComposeSizeGroupVO.groupName" clearable placeholder="请输入尺寸组名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border>
      <el-table-column type="expand">
        <template v-slot='scope'>
          <div style="width:100%;height:100%;background:red">
            <el-table :data="scope.row.sizeList" border>
              <el-table-column label="尺寸名称" prop="sizeName"></el-table-column>
              <el-table-column label="页面类型" prop="typeName">
                <template slot-scope="scope"> {{ $store.state.pms.pageType[scope.row.pageTypeCode] }} </template>
              </el-table-column>
              <el-table-column label="页面名称" prop="pageName"></el-table-column>
              <el-table-column label="宽高">
                <template slot-scope="scope"> {{ scope.row.sizeWidth }}*{{ scope.row.sizeHeight }}mm </template>
              </el-table-column>
              <el-table-column label="出血类型" prop="bleed.bleedName"></el-table-column>
              <el-table-column label="出血" width="220px">
                <template slot-scope="scope"> 上方：{{ scope.row.bleed.bleedTop }}mm 下方：{{ scope.row.bleed.bleedBottom }}mm <br> 左侧：{{ scope.row.bleed.bleedLeft }}mm 右侧：{{ scope.row.bleed.bleedRight }}mm
                  <br> 内侧：{{ scope.row.bleed.bleedIn }}mm </template>
              </el-table-column>
              <el-table-column label="码名称" prop="barCodeId">
                <template slot-scope="scope">
                  <p v-for="item in scope.row.barCodeList" :key="item.id">{{ item.barName }}</p>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="尺寸组名称" min-width="100px" prop="groupName"></el-table-column>
      <el-table-column label="尺寸组类" prop="groupCategoryName" min-width="100px"></el-table-column>
      <el-table-column label="页面名称" prop="pageName" min-width="100px"></el-table-column>
      <el-table-column label="操作" min-width="100px">
        <template slot-scope="scope">
          <span class="color-blue" @click="selected(scope.row)">选择</span>
        </template>
      </el-table-column>
    </el-table>
    <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
    <span slot="footer" class="dialog-footer">
      <el-button @click="isShow = false">取 消</el-button>
      <el-button type="primary" @click="isShow = false">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import VPagination from '@/components/Pagination/index'
import { groupListPageing, groupCategoryList } from '@/api/pms.js'
export default {
  name: 'selectSizeGroup',
  components: {
    VPagination
  },
  data () {
    return {
      isShow: false,
      tableData: [],
      searchComposeSizeGroupVO: {
        groupCategoryId: '',
        groupName: ''
      },
      sizeGroupTypeList: [],
      queryInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created () {
    this.getSizeGroupTypeList()
  },
  methods: {
    show () {
      this.isShow = true
      this.onSubmit()
    },
    selected (info) {
      this.$emit('selected', info)
      this.isShow = false
    },
    // 获取尺寸组类
    getSizeGroupTypeList () {
      groupCategoryList().then(res => {
        if (res.data.success) {
          this.sizeGroupTypeList = res.data.data
        }
      })
    },
    onSubmit () {
      groupListPageing({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, data: this.searchComposeSizeGroupVO }).then(res => {
        if (res.data.success) {
          this.queryInfo.total = res.data.data.total
          let list = res.data.data.records
          list.forEach(item => {
            // item.detail = []
            item.pageName = []
            item.sizeList.forEach(size => {
              item.pageName[item.pageName.length] = size.pageName
            })
            item.pageName = item.pageName.join(',')
          })
          this.tableData = list
        }
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    }
  }
}
</script>

<style>
</style>
